import { FC } from 'react';
import { Formik, Field, FieldArray, Form } from 'formik';
import ColorRampField from '../ColorRampField';
import styles from './ColorRampForm.module.scss';

export interface ColorRampFormProps {
  innerRef: any;
  defaultName: string;
  handleAdd: any;
  handleRemove: any;
  position: number;
  initialValues?: any;
  id: string;
}

export const ColorRampForm: FC<ColorRampFormProps> = (props) => {
  const { innerRef, handleAdd, handleRemove, position, id } = props;

  const initialValues = props.initialValues
    ? {
        name: props.defaultName,
        colors: Object.values(props.initialValues),
      }
    : {
        name: `Ramp ${position}`,
        colors: [
          {
            hex: '#ffffff',
            contrastText: '',
            contrastUi: '',
            hsl: [0, 0, 100],
            rgb: [255, 255, 255],
          },
        ],
      };
  return (
    <div className={styles.colorRampForm}>
      <Formik innerRef={innerRef} initialValues={initialValues} onSubmit={(values) => console.log(values)}>
        {({ values }) => (
          <Form>
            <ColorRampField
              rootName='colors'
              id={id}
              removeRamp={() => handleRemove(position)}
              addRamp={() => handleAdd(position + 1)}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default ColorRampForm;
